import { useAuthStore } from '@/store/auth';
import { identifyProductAnalyticsUser } from '@/telemetry/productAnalytics';

let unsubscribeProductAnalyticsAuthBridge: (() => void) | null = null;

export function ensureProductAnalyticsAuthBridge(): void {
  if (unsubscribeProductAnalyticsAuthBridge || typeof window === 'undefined') {
    return;
  }

  let lastUser = useAuthStore.getState().user;
  identifyProductAnalyticsUser(lastUser);

  unsubscribeProductAnalyticsAuthBridge = useAuthStore.subscribe((state) => {
    if (state.user === lastUser) {
      return;
    }
    lastUser = state.user;
    identifyProductAnalyticsUser(state.user);
  });
}

export function __resetProductAnalyticsAuthBridgeForTests(): void {
  unsubscribeProductAnalyticsAuthBridge?.();
  unsubscribeProductAnalyticsAuthBridge = null;
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    unsubscribeProductAnalyticsAuthBridge?.();
    unsubscribeProductAnalyticsAuthBridge = null;
  });
}
